
function Health() {

    return (
        <>
            <p>healthy  yeay!</p>
        </>
    );
}
export default Health;